import { render, staticRenderFns } from "./greenProcurement.vue?vue&type=template&id=06d721ce&scoped=true"
import script from "./greenProcurement.vue?vue&type=script&lang=js"
export * from "./greenProcurement.vue?vue&type=script&lang=js"
import style0 from "./greenProcurement.vue?vue&type=style&index=0&id=06d721ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d721ce",
  null
  
)

export default component.exports